import { useEffect, useState } from "react";
import { Modal, Button, CloseButton, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export default function CreateOrUpdateRoleModal({
  show,
  onHide,
  onSave,
  role,
}) {
  const isUpdate = Boolean(role);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  // pre-fill form when updating
  useEffect(() => {
    if (role) {
      setFormData({
        name: role.name || "",
        description: role.description || "",
      });
    } else {
      setFormData({ name: "", description: "" });
    }
  }, [role, show]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      toast.error("Role name is required");
      return;
    }

    setSubmitting(true);
    try {
      await onSave(formData, role?.id);
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="bg-body-tertiarydd border-0">
        <Modal.Title style={{ fontSize: 15 }} className="ps-2 ms-1 fw-bold">
          {isUpdate ? "Update Role" : "Add Role"}
        </Modal.Title>
        <CloseButton
          className="btn btn-circle btn-sm transition-base p-0 text-xxs"
          onClick={onHide}
        />
      </Modal.Header>

      <Modal.Body className="px-4 py-0">
        <Form>
          {/* Role Name */}
          <Form.Group className="mb-3">
            <Form.Label className="text-900 text-xs">Role Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter role name"
              name="name"
              size="sm"
              value={formData.name}
              onChange={handleChange}
              className="text-xs"
            />
          </Form.Group>

          {/* Description */}
          <Form.Group className="mb-3">
            <Form.Label className="text-900 text-xs">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Short description for this role"
              name="description"
              size="sm"
              value={formData.description}
              onChange={handleChange}
              className="text-xs"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 justify-content-start">
        <Button
          variant="secondary"
          onClick={onHide}
          size="sm"
          className="text-sm"
        >
          Close
        </Button>

        {submitting ? (
          <Spinner animation="border" size="md" variant="success" />
        ) : (
          <Button
            variant="success"
            size="sm"
            className="text-sm"
            onClick={handleSubmit}
          >
            {isUpdate ? "Update" : "Save"}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
